import { Storage } from "aws-amplify";

export async function s3Upload(file, folder) {
    const filename = `${folder}/${file.name}`;

  const stored = await Storage.put(filename, file, {
    contentType: file.type
    });
    

  return stored.key;
}

export async function s3Delete(key) {
 

const stored = await Storage.remove(key);
  

return stored.key;
}

export async function s3GetURL(file, folder) {
  let filename = null;  
  if (folder != null){
      filename = `${folder}/${file}`;
    }else{
      filename = `${file}`;
    }
    console.log("File name-"+filename);
    const url = await Storage.get(filename, { expires: 900,level: 'public' });
    console.log(url);
    return url;
    
            
}

export async function s3GetFolderFiles(folder,prefix) {
    //const currentConfig = Storage.configure();
    //console.log(currentConfig);
    console.log(`${folder}/${prefix}`);
    const result  = await Storage.list(`${folder}/${prefix}`);
    console.log(result);
    return result;
    
    
   
}